import { MaskedLines, FadeIn } from "@/components/Reveal";

export const PageHero = ({ overline, titleLines, subtitle }) => (
  <section className="relative overflow-hidden pt-36 pb-16 lg:pt-44">
    <div className="radial-glow pointer-events-none absolute inset-0" />
    <div className="grid-bg pointer-events-none absolute inset-0 opacity-50 [mask-image:radial-gradient(circle_at_50%_0%,black,transparent_70%)]" />
    <div className="relative mx-auto max-w-4xl px-5 text-center lg:px-8">
      {overline && (
        <FadeIn className="mb-5">
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-brand">{overline}</span>
        </FadeIn>
      )}
      <h1 className="font-heading text-5xl font-bold leading-[0.95] tracking-tighter text-white sm:text-6xl">
        <MaskedLines lines={titleLines} />
      </h1>
      {subtitle && (
        <FadeIn delay={0.4}>
          <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-zinc-400">{subtitle}</p>
        </FadeIn>
      )}
    </div>
  </section>
);
